import { IssueType } from '../../database/issue.interface';

/**
 * Portal Issue DTOs (PD-13705)
 *
 * Contract for the storefront "Submit an Issue" widget — a signed-in
 * customer sends a categorized inquiry that lands as an `issue` record
 * in the CRM, linked to their active client.
 */

/**
 * Categories a portal customer may pick from. Deliberately a subset of
 * `IssueType` — `Accounting` is an internal triage category and is not
 * offered to customers.
 */
export const PORTAL_ISSUE_TYPES: ReadonlyArray<IssueType> = [
	IssueType.QUESTION,
	IssueType.REQUEST,
	IssueType.PROBLEM,
];

/** Server-enforced field limits, shared so the widget can mirror them. */
export const PORTAL_ISSUE_SUBJECT_MAX_LENGTH = 255;
export const PORTAL_ISSUE_MESSAGE_MAX_LENGTH = 10000;

export interface PortalSubmitIssueRequestDto {
	/** Becomes the issue name. */
	subject: string;
	/** One of PORTAL_ISSUE_TYPES; maps to issue.type. */
	type: IssueType;
	/** Becomes the issue description. */
	message: string;
}

export interface PortalSubmitIssueResponseDto {
	/** The created issue id — shown to the customer as their reference number. */
	issueId: number;
}
